import { render, staticRenderFns } from "./DonePHQ9s.vue?vue&type=template&id=61ff7fb1&"
import script from "./DonePHQ9s.vue?vue&type=script&lang=js&"
export * from "./DonePHQ9s.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VForm,VIcon,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1532393991/src/playtient-web-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61ff7fb1')) {
      api.createRecord('61ff7fb1', component.options)
    } else {
      api.reload('61ff7fb1', component.options)
    }
    module.hot.accept("./DonePHQ9s.vue?vue&type=template&id=61ff7fb1&", function () {
      api.rerender('61ff7fb1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DonePHQ9s.vue"
export default component.exports